import React, { useMemo } from 'react';

import type { User } from 'app/typings';
import { UserRole } from 'app/typings';

type UserContextType = {
  token?: string;
  user?: User;
  isAdmin: boolean;
  isSuperAdmin: boolean;
};

type Props = {
  children: React.ReactNode;
  token?: string;
  user?: User;
};

export const UserContext = React.createContext<UserContextType>({
  isAdmin: false,
  isSuperAdmin: false,
});

export const UserContextProvider = ({ children, token, user }: Props) => {
  const isAdmin = useMemo(() => {
    return user?.role === UserRole.Admin || user?.role === UserRole.SuperAdmin;
  }, [user]);

  const isSuperAdmin = useMemo(() => {
    return user?.role === UserRole.SuperAdmin;
  }, [user?.role]);

  return (
    <UserContext.Provider value={{ token, user, isAdmin, isSuperAdmin }}>
      {children}
    </UserContext.Provider>
  );
};
